import React from "react";
import { Link } from "react-router-dom";

// Persistent legal links shown on marketing, auth and in-app surfaces.
export default function LegalFooter({ className = "", variant = "light" }) {
  const muted = variant === "dark" ? "text-slate-400" : "text-slate-400";
  const link = variant === "dark" ? "text-slate-200 hover:text-white" : "text-slate-500 hover:text-slate-800";
  return (
    <footer className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs ${muted} ${className}`} data-testid="legal-footer">
      <span>© {new Date().getFullYear()} FD Check Ltd</span>
      <span aria-hidden>·</span>
      <Link to="/legal/privacy" className={`font-medium ${link}`} data-testid="footer-privacy-link">Privacy Policy</Link>
      <span aria-hidden>·</span>
      <Link to="/legal/terms" className={`font-medium ${link}`} data-testid="footer-terms-link">Terms of Use</Link>
    </footer>
  );
}
